export const SET_ORGANIZATION_LICENSES = 'setOrganizationLicenses'
export const SET_ORGANIZATION_ID = 'setOrganizationId'
export const SET_ORGANIZATION_NAME = 'setOrganizationName'
export const SET_ORGANIZATION_SUPPORT_EMAIL = 'setOrganizationSupportEmail'
export const SET_ORGANIZATION_PHONE_NUMBER = 'setOrganizationPhoneNumber'
export const SET_ORGANIZATION_TIME_ZONE = 'setOrganizationTimeZone'

const setOrganizationLicenses = (state, payload) => {
    state.licenses = payload
}

const setOrganizationId = (state, payload) => {
    state.id = payload
}

const setOrganizationName = (state, payload) => {
    state.name = payload
}

const setOrganizationSupportEmail = (state, payload) => {
    state.supportEmail = payload
}

const setOrganizationPhoneNumber = (state, payload) => {
    state.phoneNumber = payload
}

const setOrganizationTimeZone = (state, payload) => {
    state.timeZone = payload
}

export default {
    setOrganizationLicenses,
    setOrganizationId,
    setOrganizationName,
    setOrganizationSupportEmail,
    setOrganizationPhoneNumber,
    setOrganizationTimeZone
}
